var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VWrapper',{attrs:{"title":"posSync.index","sub-title":"common.overview"}},[_c('VCard',{staticClass:"pa-4"},[_c('PosSyncTable',{attrs:{"items":_vm.items,"total":_vm.total,"venues":_vm.venues},on:{"page":function($event){return _vm.fetch($event.page)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }